// @flow
import type { SampleList } from "../../lib/OnlineTypes";
import React, { useState, Fragment } from "react";
import Samples from "./Samples";
import Button from "../Button";
import PesticideSummarySearch from "./PesticideSummarySearch";
import { DefaultPaddedContainerNoShadow } from "./Theme";
import { fetchSamples } from "./Utils/SamplesFetch";
import moment from "moment";
import DropDown from "../DropDown";
import styled from "styled-components";
import PesticideSummaryReport from "./PesticideSummaryReport";

const Container = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  margin-top: 20px;
`;

export default function PesticideSummary({
  company_id,
  canFindCompany,
  runSearch = false,
  clientView = true,
  showTestingBreakdown,
  placeholder_image,
}) {
  const [data, setData] = useState(null);
  const [searchParams, setSearchParams] = useState(null);

  const updateData = (data, formParams) => {
    setSearchParams(formParams);
    setData(data);
  };

  const options = {
    showTestingBreakdown,
  };

  return (
    <div>
      <div style={{ marginBottom: 20 }} className="alert alert-default">
        This report only shows comparisons against EU MRLs
      </div>
      <PesticideSummarySearch
        company_id={company_id}
        canFindCompany={false}
        onLoad={updateData}
        runSearch={runSearch}
      />
      {data && <PesticideSummaryReport data={data} options={options} />}
      {placeholder_image &&
        !data && (
          <div
            style={{
              margin: "0 auto",
              display: "table",
              marginTop: "20px",
            }}
          >
            <img src={placeholder_image} style={{ maxWidth: "100vw" }} />
          </div>
        )}
    </div>
  );
}
